import { IBaseCitysData } from '../../../../types/system/base/citys';
import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';

const hostUrl = getHostbaseUrl();

/**
 * 系统设置 - 基础设置 - 城市获取
 */
export async function getSystemCitys() {
  let data = [] as IBaseCitysData[];

  try {
    const { code, context, message } = await Http.post<IBaseCitysData[]>(`${hostUrl}/side/sys/region/listTree`);

    if (code === EAxiosResponseCode.Succeed) {
      const items = context || [] as IBaseCitysData[];

      data = items || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 系统设置 - 基础设置 - 删除
 */
export async function deleteSystemCitys(id: number) {

  try {
    const { code, message } = await Http.delete<{ data: IBaseCitysData[] }>(`${hostUrl}/iam/system/deleteCitys`, { id });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * 系统设置 - 基础设置 - 城市 修改
 */
export async function editSystemCitys(cityCode: number, label: string) {

  try {
    const { code, message } = await Http.post<{ data: IBaseCitysData[] }>(`${hostUrl}/iam/system/editCitys`, {
      cityCode,
      label,
    });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * 系统设置 - 基础设置 - 城市 修改
 */
export async function addSystemCitys(cityCode: number, label: string) {

  try {
    const { code, message } = await Http.post<{ data: IBaseCitysData[] }>(`${hostUrl}/iam/system/addCitys`, {
      cityCode,
      label,
    });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}
